import { Fragment } from 'react';
import { useIsMobile } from '@hooks';
import Modal from '@components/Modal';
import Spacer from '@components/Spacer';
import DocumentRow from './DocumentRow';
import s from './DocumentsListModal.module.scss';

type ThisCompiledDocument = Parameters<typeof DocumentRow>[0]['compiledDocument'] & {
  id: string;
  isNew?: true;
};
type ExternalCompledDocument = Omit<ThisCompiledDocument, 'isNew'>;

type Props = {
  creatorSlug: string;
  compiledDocuments: Array<ExternalCompledDocument>;
  onClose: NonNullable<Parameters<typeof Modal>[0]['onClose']>;
};

const DocumentsListViewModal: React.FC<Props> = ({ creatorSlug, compiledDocuments, onClose }) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      isPinnedToBottom={isMobile}
      title={'Documents'}
      onClose={onClose}
      hasCloseOnActions={false}
      hasForm={false}
    >
      <div className={s['compiled-documents-modal-content']}>
        {compiledDocuments.map(compiledDocument => (
          <Fragment key={compiledDocument.id}>
            <DocumentRow
              creatorSlug={creatorSlug}
              compiledDocument={compiledDocument}
            />
            <Spacer size={24} />
          </Fragment>
        ))}
      </div>
    </Modal>
  );
};

export default DocumentsListViewModal;
